export default __webpack_public_path__ + "static/media/3171.678dbc00.svg";